<template>
  <div id="app" :class="loggedIn ? 'flex ' + isStaging : isStaging">
    <PageLoader />

    <template
      v-if="
        loggedIn &&
          this.getTokenExpiry &&
          this.getTokenExpiry > new Date().getTime() / 1000
      "
    >
      <div
        class="sidebar"
        :class="sidebarOpen ? 'sidebar--open' : ''"
        @click.self="$store.commit('closeSidebar')"
      >
        <div class="sidebar__menu">
          <div class="px-2 py-3 border-b border-white mb-2">
            <div class="flex items-center">
              <font-awesome-icon
                class="mr-2 lg:text-white"
                :icon="['fas', 'user']"
                size="3x"
              />
              <div class="block lg:text-white">
                <span class="block poppins">{{ this.getLoggedInUser }}</span>
                <span class="block text-sm">[{{ this.getRole }}]</span>
              </div>
            </div>
          </div>
          <router-link :to="{ name: 'Profile' }">Your Profile</router-link>
          <router-link :to="{ name: 'DashboardMain' }">Dashboard</router-link>
          <router-link
            :to="{ name: 'DepositList' }"
            v-if="userCan('read.deposit')"
            >Deposit</router-link
          >
          <router-link
            :to="{ name: 'WithdrawList' }"
            v-if="userCan('read.withdraw')"
            >Withdraw</router-link
          >
          <router-link
            :to="{ name: 'TransferList' }"
            v-if="userCan('read.transfer')"
            >Transfer</router-link
          >
          <router-link :to="{ name: 'BonusList' }" v-if="userCan('read.bonus')"
            >Bonus</router-link
          >
          <router-link :to="{ name: 'AssetList' }" v-if="userCan('read.asset')"
            >Asset</router-link
          >
          <router-link :to="{ name: 'BankList' }" v-if="userCan('read.bank')"
            >Bank</router-link
          >
          <router-link :to="{ name: 'UserList' }" v-if="userCan('read.user')"
            >User</router-link
          >
          <router-link
            :to="{ name: 'UserRoleList' }"
            v-if="userCan('read.role')"
            >User Role</router-link
          >
          <router-link
            :to="{ name: 'ProductList' }"
            v-if="userCan('read.product')"
            >Product</router-link
          >
          <router-link
            :to="{ name: 'BankAccountList' }"
            v-if="userCan('read.bank-account')"
            >Bank Account</router-link
          >
          <router-link
            :to="{ name: 'MemberList' }"
            v-if="userCan('read.member')"
            >Member</router-link
          >
          <button
            v-if="userCan('read.nexus-sync')"
            @click="toggleNexusMenu"
            class="
              lg:text-white
              flex
              items-center
              justify-between
              w-full
              p-2
              text-left
              lg:hover:bg-gray-900
              duration-100
            "
          >
            Nexus <font-awesome-icon :icon="['fas', 'angle-down']" />
          </button>
          <div v-if="nexusMenu">
            <router-link :to="{ name: 'NexusDepositList' }"
              ><span class="pl-4">Deposit</span></router-link
            >
            <router-link :to="{ name: 'NexusWithdrawList' }"
              ><span class="pl-4">Withdraw</span></router-link
            >
            <router-link
              :to="{ name: 'NexusSyncSetting' }"
              v-if="userCan('update.nexus-sync')"
              ><span class="pl-4">Setting</span></router-link
            >
            <router-link :to="{ name: 'NexusSyncReport' }"
              ><span class="pl-4">Report</span></router-link
            >
          </div>
          <button
            v-if="userCan('read.report')"
            @click="toggleReportMenu"
            class="
              lg:text-white
              flex
              items-center
              justify-between
              w-full
              p-2
              text-left
              lg:hover:bg-gray-900
              duration-100
            "
          >
            Report <font-awesome-icon :icon="['fas', 'angle-down']" />
          </button>
          <div v-if="reportMenu">
            <router-link :to="{ name: 'ReportMemberTransaction' }"
              ><span class="pl-4">Member Transaction</span></router-link
            >
          </div>

          <button
            v-if="
              userCan('export.transaction') ||
                userCan('export.crm') ||
                userCan('export.bank-history') ||
                userCan('export.bank-balance')
            "
            @click="toggleExportMenu"
            class="
              lg:text-white
              flex
              items-center
              justify-between
              w-full
              p-2
              text-left
              lg:hover:bg-gray-900
              duration-100
            "
          >
            Export <font-awesome-icon :icon="['fas', 'angle-down']" />
          </button>
          <div v-if="exportMenu">
            <router-link :to="{ name: 'ExportMemberTransaction' }"
              ><span class="pl-4">Member Transaction</span></router-link
            >
            <router-link :to="{ name: 'ExportBankTransaction' }"
              ><span class="pl-4">Bank Transaction</span></router-link
            >
            <router-link
              v-if="userCan('export.bank-balance')"
              :to="{ name: 'ExportBankBalance' }"
              ><span class="pl-4">Bank Balance</span></router-link
            >
            <router-link
              v-if="userCan('export.bank-history')"
              :to="{ name: 'ExportBankHistory' }"
              ><span class="pl-4">Bank History</span></router-link
            >
            <router-link
              v-if="userCan('export.crm')"
              :to="{ name: 'ExportCrm' }"
              ><span class="pl-4">CRM</span></router-link
            >
          </div>

          <router-link
            :to="{ name: 'SupportTicketList' }"
            class="flex-no-wrap"
            style="display: flex !important"
            ><span class="block">Support Ticket</span>
            <span
              v-if="ticketBadge"
              class="
                bg-red-700
                flex
                items-center
                justify-center
                poppins
                font-medium
                text-white
                rounded-full
                h-6
                w-6
                text-xs
                ml-2
              "
              >{{ $countTicket }}</span
            ></router-link
          >

          <button
            @click="logout"
            class="
              lg:text-white
              outline-none
              block
              w-full
              p-2
              text-left
              lg:hover:bg-gray-900
              duration-100
            "
          >
            Logout
            <font-awesome-icon class="ml-1" :icon="['fas', 'sign-out-alt']" />
          </button>
        </div>
      </div>
      <div class="topbar">
        <div class="flex items-center text-white mr-2">
          <font-awesome-icon
            class="mr-2 text-white"
            :icon="['fas', 'user']"
            size="lg"
          />
          {{ this.getLoggedInUser }} [{{ this.getRole }}] -
          <span class="block ml-1 lg:hidden">v{{ checkVersion }}</span>
        </div>
        <button
          @click="$store.commit('openSidebar')"
          type="button"
          class="focus:outline-none"
        >
          <font-awesome-icon
            :icon="['fas', 'bars']"
            size="lg"
            class="text-white"
          />
        </button>
      </div>
      <div class="content">
        <div class="p-4" :class="isStaging == 'staging' ? 'staging__bg' : ''">
          <div class="mb-4 flex">
            <div
              class="
                flex
                items-center
                flex-wrap
                w-full
                justify-between
                lg:justify-end
                lg:flex-no-wrap
              "
            >
              <div
                class="flex flex-wrap sm:flex-no-wrap w-full"
                v-if="
                  userCan('update.deposit') ||
                    userCan('update.withdraw') ||
                    userCan('update.transfer')
                "
              >
                <form
                  class="
                    w-full
                    mb-2
                    order-2
                    sm:order-1
                    sm:mb-0
                    sm:mr-2
                    sm:w-6/12
                    lg:w-5/12
                  "
                  @submit.prevent="submitGlobalSearch"
                >
                  <input
                    type="text"
                    class="form__input"
                    placeholder="Search member"
                    v-model="globalSearch"
                  />
                </form>

                <div
                  class="
                    flex flex-wrap
                    order-1
                    mb-2
                    sm:order-2
                    sm:mb-0
                    sm:items-center
                  "
                >
                  <router-link
                    :to="{ name: 'DepositCreate' }"
                    class="button button--primary poppins"
                    v-if="userCan('create.deposit')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'plus-circle']"
                      class="mr-1"
                    />Deposit
                  </router-link>

                  <router-link
                    :to="{ name: 'WithdrawCreate' }"
                    class="button button--primary poppins mx-2"
                    v-if="userCan('create.withdraw')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'plus-circle']"
                      class="mr-1"
                    />Withdraw
                  </router-link>

                  <router-link
                    :to="{ name: 'TransferCreate' }"
                    class="button button--primary poppins"
                    v-if="userCan('create.transfer')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'plus-circle']"
                      class="mr-1"
                    />Transfer
                  </router-link>
                </div>
              </div>
            </div>

            <div class="flex items-center">
              <span
                class="
                  bg-blue-500
                  rounded-lg
                  px-4
                  text-sm
                  h-8
                  text-white
                  items-center
                  hidden
                  lg:flex
                "
                >v{{ checkVersion }}</span
              >
            </div>
          </div>

          <div class="rounded mb-4 bg-red-600" v-if="versionErr">
            <p class="text-sm p-4 text-white">
              Warning: You are not on the latest version
              <strong>(v{{ this.$appVersion }})</strong>. Please refresh your
              browser using <strong>Ctrl F5</strong> and
              <strong>Ctrl Shift R</strong>.
            </p>
          </div>

          <FormNote class="mb-4" v-if="showAnnouncement">
            Note:
            <ul class="list-disc ml-4">
              <li
                class="mt-1"
                v-for="(ann, index) in this.$appAnnouncement"
                v-html="ann"
                :key="index"
              ></li>
            </ul>
          </FormNote>

          <router-view />
        </div>
      </div>
    </template>

    <!-- Not logged in, no token expiry -->
    <template v-else>
      <div class="flex items-center justify-end relative">
        <span
          class="
          mt-4 mr-4
                  bg-blue-500
                  rounded-lg
                  px-4
                  text-sm
                  h-8
                  text-white
                  items-center
                  flex
                "
          >v{{ checkVersion }}</span
        >
      </div>
      <div class="rounded mb-4 bg-red-600" v-if="versionErr">
        <p class="text-sm p-4 text-white">
          Warning: You are not on the latest version
          <strong>(v{{ appVer }})</strong>. Please refresh your browser using
          <strong>Ctrl F5</strong> and <strong>Ctrl Shift R</strong>.
        </p>
      </div>
      <router-view />
    </template>
  </div>
</template>

<script>
import PageLoader from "@/components/PageLoader";

export default {
  data: () => {
    return {
      menuOpen: false,
      reportMenu: false,
      exportMenu: false,
      nexusMenu: false,
      globalSearch: "",
      versionErr: false,
      ticketBadge: false,
      showAnnouncement: false,
      appVer: null,
    };
  },
  components: {
    PageLoader,
  },
  computed: {
    sidebarOpen() {
      return this.$store.getters.isSidebarOpened;
    },
    loggedIn() {
      return (
        this.$store.getters.isLoggedIn &&
        this.$store.getters.getTokenExpiry > new Date().getTime() / 1000
      );
    },
    getToken() {
      return this.$store.getters.getToken;
    },
    getTokenExpiry() {
      return this.$store.getters.getTokenExpiry;
    },
    getRole() {
      return this.$store.getters.getRole;
    },
    getLoggedInUser() {
      return this.$store.getters.getLoggedInUser;
    },
    isStaging() {
      return process.env.VUE_APP_ENV;
    },
    checkVersion() {
      return process.env.VUE_APP_VERSION;
    },
  },
  methods: {
    submitGlobalSearch() {
      this.$router.push(
        {
          name: "SearchList",
          params: { search: this.globalSearch },
        },
        () => {
          this.globalSearch = "";
        }
      );
    },
    logout() {
      this.$store.commit("toggleLoading");
      this.$store.dispatch("logout").then(() => {
        this.$store.commit(
          "changeLoginMessage",
          "Please login to use the site"
        );
        this.$router.push({ name: "Login" });
        this.$store.commit("toggleLoading");
      });
    },
    toggleReportMenu() {
      this.reportMenu = this.reportMenu ? false : true;
    },
    toggleNexusMenu() {
      this.nexusMenu = this.nexusMenu ? false : true;
    },
    toggleExportMenu() {
      this.exportMenu = this.exportMenu ? false : true;
    },
  },
  created() {},
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || "Kedai Kopi";

        if (!this.loggedIn) {
          this.$http
            .get(process.env.VUE_APP_API_URL + "/auth/bypass/")
            .then()
            .catch((e) => {
              if (
                e.response.data.version !=
                process.env.VUE_APP_VERSION.toString()
              ) {
                this.versionErr = true;
                this.appVer = e.response.data.version;
              }
            });
        }

        const nexusRoute = [
          "NexusDepositList",
          "NexusWithdrawList",
          "NexusSyncSetting",
          "NexusSyncReport",
        ];
        const exportRoute = ["ExportTransaction"];
        const reportRoute = ["ReportTransaction"];

        const routeName = to.name;

        if (nexusRoute.includes(routeName)) {
          this.nexusMenu = true;
        } else if (exportRoute.includes(routeName)) {
          this.exportMenu = true;
        } else if (reportRoute.includes(routeName)) {
          this.reportMenu = true;
        }

        if (this.$versionMismatch) {
          this.versionErr = true;
        } else {
          this.versionErr = false;
        }

        if (this.$appAnnouncement) {
          if (this.$appAnnouncement.length > 0) {
            this.showAnnouncement = true;
          } else {
            this.showAnnouncement = false;
          }
        } else {
          this.showAnnouncement = false;
        }

        if (this.$countTicket) {
          this.ticketBadge = true;
        }
      },
    },
    loggedIn(currentState) {
      if (currentState == false) {
        this.$router.push({ name: "Login" }).catch(() => {});
      }
    },
  },
};
</script>
